import { render, staticRenderFns } from "./lifelist.vue?vue&type=template&id=ec1cff94&scoped=true"
import script from "./lifelist.vue?vue&type=script&lang=js"
export * from "./lifelist.vue?vue&type=script&lang=js"
import style0 from "./lifelist.vue?vue&type=style&index=0&id=ec1cff94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1cff94",
  null
  
)

export default component.exports